import * as actions from "../actions/accounting-actions";
import { AccountingModuleState } from "../store/AccountingModuleState";

/**
 * The Accounting Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function accountingReducer(state = new AccountingModuleState(), action: IReduxAction) {
    switch (action.type) {
        case actions.ACCOUNTING_CREDIT_CATEGORIES_FETCH_SUCCESS:
            return Object.assign({}, state, {
                creditCategories: action.payload
            });
        case actions.ACCOUNTING_CREDIT_REASONS_FETCH_SUCCESS:
            return Object.assign({}, state, {
                creditReasons: action.payload
            });        
        default:
            return state;
    }
}
